export default {
  HOME: 'home',
  ARTICLE: 'article',
  TOPIC: 'topic',
  SEARCH: 'search',
  ICF: 'ICF',
  PAYPALGUIDE: 'PAYPAL_HELP_GUIDE',
  COMPLAINTS: 'complaints',
  HOME_V2: 'homeV2',
};
